// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","title":"App_title__YS7Xx","container":"App_container__Rt8T2","logo":"App_logo__7Edbg"};